import { ReactNode, useEffect } from 'react';
import { IButtonProps } from '@/common/components/Button/Button';
import { INavigationStepsProps } from '@/common/components/NavigationSteps/NavigationSteps';
import { Stack } from '@/common/components/Stack/Stack';
import { useFlowLayout } from '@/common/layouts/FlowLayout/FlowLayout.context';

export type TFlowLayoutStepProps = {
  children: ReactNode;
} & INavigationStepsProps['steps'][number];

export function FlowLayoutStep({ children }: TFlowLayoutStepProps) {
  return children;
}

export type TFlowLayoutContentProps = {
  canGoBack?: boolean;
  primaryAction?: IButtonProps;
  secondaryAction?: IButtonProps;
  tertiaryAction?: IButtonProps;
  children: ReactNode;
};

export function FlowLayoutContent({
  canGoBack = true,
  primaryAction,
  secondaryAction,
  tertiaryAction,
  children,
}: TFlowLayoutContentProps) {
  const { updateFlow } = useFlowLayout();

  useEffect(() => {
    updateFlow({ canGoBack, primaryAction, secondaryAction, tertiaryAction });
  }, [canGoBack, primaryAction, secondaryAction, tertiaryAction, updateFlow]);

  return <Stack gap="page">{children}</Stack>;
}
